export default __webpack_public_path__ + "static/1-59d37a6993759e213046308bf6cd3d13.png";